import axios from "axios";
import { getShippingList, getShippingFilterOptions } from "../../api";
import useShippingStore from "../stores/shipping";
import toast from "react-hot-toast";

export const loadShippingOfficeOptions = async () => {
  const store = useShippingStore.getState();
  if (store.officeOptionsLoaded) {
    return store.officeOptions;
  }
  try {
    const response = await getShippingFilterOptions({});
    const offices = Array.isArray(response?.data?.office)
      ? response.data.office
      : [];
    useShippingStore.getState().setOfficeOptions(offices);

    const { shippingFilterSearchQuery, setShippingFilterSearchQuery } =
      useShippingStore.getState();
    const currentlySelected = shippingFilterSearchQuery.office ?? "";
    if (offices.length === 1 && (!currentlySelected || currentlySelected === "")) {
      setShippingFilterSearchQuery({ office: offices[0], page: 1 });
    }
    return offices;
  } catch {
    useShippingStore.getState().setOfficeOptions([]);
    return [];
  }
};

export const fetchShippingList = async (filters = {}, cancelToken = null) => {
  try {
    const store = useShippingStore.getState();
    const fromRequest = filters.office;
    const fromStore = store.shippingFilterSearchQuery.office ?? "";
    const normalizeOffice = (v) => {
      if (typeof v === "string" && v.trim() !== "") {
        return v.trim();
      }
      if (Array.isArray(v) && v.length > 0 && typeof v[0] === "string") {
        return v[0].trim();
      }
      return "";
    };
    const office = normalizeOffice(fromRequest) || normalizeOffice(fromStore);

    if (office === "") {
      store.setShippingList([]);
      store.setPageCount(1);
      store.setCurrentPage(1);
      store.setTotalItems(0);
      store.setItemsPerPage(store.itemsPerPage ?? 20);
      return {
        status: true,
        data: [],
        pagination: {
          current_page: 1,
          last_page: 1,
          per_page: store.itemsPerPage ?? 20,
          total: 0,
          from: null,
          to: null,
        },
      };
    }

    const params = {
      page: filters.page ?? store.currentPage,
      search: filters.search ?? store.searchQuery,
      office,
      type: filters.type ?? store.shippingFilterSearchQuery.type ?? "All",
      courier: filters.courier ?? store.shippingFilterSearchQuery.courier ?? "All",
      order_date_from:
        filters.orderDate?.from ?? store.shippingFilterSearchQuery.orderDate?.from,
      order_date_to:
        filters.orderDate?.to ?? store.shippingFilterSearchQuery.orderDate?.to,
      ship_date_from:
        filters.shipDate?.from ?? store.shippingFilterSearchQuery.shipDate?.from,
      ship_date_to:
        filters.shipDate?.to ?? store.shippingFilterSearchQuery.shipDate?.to,
      sort_field: filters.sortBy ?? store.shippingFilterSearchQuery.sortBy,
      sort_direction:
        filters.sortValue ?? store.shippingFilterSearchQuery.sortValue,
      per_page: filters.itemsPerPage ?? store.itemsPerPage,
    };

    const response = await getShippingList(
      params,
      cancelToken ? { cancelToken } : {},
    );

    if (response.status) {
      store.setShippingList(
        Array.isArray(response.data) ? response.data : [],
      );
      if (response.pagination) {
        store.setPageCount(response.pagination.last_page);
        store.setCurrentPage(response.pagination.current_page);
        store.setTotalItems(response.pagination.total);
        store.setItemsPerPage(response.pagination.per_page);
      }
    } else {
      store.setShippingList([]);
      store.setPageCount(1);
      store.setCurrentPage(1);
      store.setTotalItems(0);
      store.setItemsPerPage(20);
    }

    return response;
  } catch (error) {
    if (axios.isCancel(error)) {
      return;
    }
    console.error("Error fetching shipping list:", error);
    const store = useShippingStore.getState();
    store.setShippingList([]);
    store.setPageCount(1);
    store.setCurrentPage(1);
    store.setTotalItems(0);
    store.setItemsPerPage(20);
    const msg =
      (error && error.data && error.data.message) ||
      (error && error.response && error.response.data && error.response.data.message);
    toast.error(msg || "Failed to load shipping records");
    throw error;
  }
};
